import {
  GET_DMPLIST_LOADING,
  GET_DMPLIST_SUCCESS,
  GET_DMPLIST_ERROR,
  CLEAR_DMP_LIST,
} from "../../../constant/actionTypes";

const getDmpList = (state = {}, action) => {
  switch (action.type) {
    case GET_DMPLIST_LOADING: {
      let obj = {
        ...state,
        loading: true,
      };
      return obj;
    }
    case GET_DMPLIST_SUCCESS: {
      let obj = {
        ...state,
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case GET_DMPLIST_ERROR: {
      let obj = {
        ...state,
        loading: false,
        status: action.response,
      };
      return obj;
    }
    case CLEAR_DMP_LIST: {
      let obj = {
        ...state,
        loading: false,
        data: undefined,
      };
      return obj;
    }
    default:
      return state;
  }
};

export default getDmpList;
